import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Login'
import Register from '@/components/Register'
import Recover from '@/components/Recover'
import Reset from '@/components/Reset'
import Confirm from '@/components/Confirm'
import VerifySuccess from '@/components/VerifySuccess'
import VerifyError from '@/components/VerifyError'
import NoActive from '@/components/Noactive'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    props: (route) => ({
      redirect: route.query.r
    })
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/recover',
    name: 'Recover',
    component: Recover
  },
  {
    path: '/confirm/:token',
    name: 'Confirm',
    component: Confirm,
    props: true
  },
  {
    path: '/reset/:token',
    name: 'Reset',
    component: Reset,
    props: true
  },
  {
    path: '/verify_success',
    name: 'VerifySuccess',
    component: VerifySuccess
  },
  {
    path: '/verify_error',
    name: 'VerifyError',
    component: VerifyError
  },
  {
    path: '/no_active',
    name: 'NoActive',
    component: NoActive
  }
]

const router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js